export type NavItem = {
  label: string
  /** brands = brand mega panel, links = column of sub pages, flat = direct link */
  kind: 'brands' | 'links' | 'flat'
  children?: string[]
}

export const NAV_ITEMS: NavItem[] = [
  { label: 'Blagovne znamke', kind: 'brands' },
  { label: 'Vozila na zalogi', kind: 'flat' },
  {
    label: 'Storitve',
    kind: 'links',
    children: ['Servis vozil', 'Cenitev škod', 'Kleparsko ličarska popravila'],
  },
  { label: 'O nas', kind: 'links', children: ['O skupini AutoWallis', 'Ekipa', 'Novice'] },
  {
    label: 'Aktualno',
    kind: 'links',
    children: ['BMW serije 1', 'BMW X3', 'BMW Service 4 Plus'],
  },
  { label: 'Kontakt', kind: 'flat' },
  { label: 'Zaposlitev', kind: 'flat' },
]

export type BrandActionKey = 'stock' | 'test' | 'service'

export const BRAND_ACTIONS: { key: BrandActionKey; label: string }[] = [
  { key: 'stock', label: 'Zaloga' },
  { key: 'test', label: 'Testna vožnja' },
  { key: 'service', label: 'Servis' },
]
